var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2E5FCA",
  strokeWidth: 1.75,
  d: "M1.015 18.974q-.261.38 3.994-4.793zM9.403 1a7.19 7.19 0 1 0 0 14.38 7.19 7.19 0 0 0 0-14.38z"
})));
export default SvgSearch;